import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import EditOutlined from "@mui/icons-material/EditOutlined";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useGetPaymentIntegrationDetailQuery } from "store/services/paymentIntegrationApi";
import PaymentIntegrationBasicDetail from "./PaymentIntegrationComponent/PaymentIntegrationBasicDetail";

const PaymentIntegrationDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Payment Integrations", path: "/app/crm/paymentIntegration/list" },
    { title: "Payment Integration Detail" },
  ];

  // RTK Query
  const {
    data: paymentIntegrationDetail,
    isLoading: loadingPaymentIntegrationDetail,
    error,
  } = useGetPaymentIntegrationDetailQuery(id);

  const PageActions = () => (
    <Link to={`/app/crm/paymentIntegration/${id}/edit`}>
      <Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button>
    </Link>
  );

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingPaymentIntegrationDetail}
      headerActions={<PageActions />}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        {!loadingPaymentIntegrationDetail ? (
          <PaymentIntegrationBasicDetail paymentIntegrationDetail={paymentIntegrationDetail} />
        ) : (
          <InfoGridSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentIntegrationDetailScreen;